import React, { useState, useEffect } from 'react'
import { ButtonAddHLPure, DialogYesNoHLPure, DropDownBtnHLPure, GridSelectionHLPure, SearchBarHLPure, SimpleLoading, LabelModalPure } from '../../pures';
import { filterBy } from '@progress/kendo-data-query';
import { Container, Grid, useMediaQuery } from '@material-ui/core';
import DigitalVaultDocumentAction from '../../actions/digital-vault-document/digital-vault-document.action';
import { useTranslation } from 'react-i18next';
import './digital-vault-bin.css'

const HeaderColumns = (props) => {
    return <span className={(props.title === props.t('digitalVaultBinView.grid.title.1')) ? 'grid-header-one' : 'grid-headers'}>{props.title}</span>;
};

const CellColumnName = (props) => {
    return (
        <td>
            <div className='grid-cell-double-container-margin-left'>
                <p className='grid-cell-titles'>{props.dataItem.name}</p>
                <p className='grid-cell-subtitles'>{props.dataItem.companyName}</p>
            </div>
        </td>
    )
}

const CellColumnDate = (props) => {
    return (
        <td>
            <div>
                <p className={'grid-cell-subtitles'}>{props.dataItem.deletedDate}</p>
            </div>
        </td>
    )
}

const DigitalVaultBinView = (props) => {
    const {
        isLoading,
        companies,
        selectedCompanyId,
        setSelectedCompanyId,
        documents,
        selectedDocument,
        setSelectedDocument,
        viewDeleteDialog,
        setViewDeleteDialog,
        deleteMany,
        deleteDocument,
        restoreDocument,
    } = props;

    const { t } = useTranslation()
    const [skip, setSkip] = useState(0);

    const [documentsDatagrid, setDocumentsDatagrid] = useState(documents);
    const [documentSearch, setDocumentSearch] = useState('');

    useEffect(() => {
        let filter = {
            logic: 'and',
            filters: [
                {
                    field: 'name',
                    operator: 'contains',
                    value: documentSearch,
                }
            ],
        }
        if (selectedCompanyId !== '0') {
            filter.filters.push({
                field: 'companyId',
                operator: 'eq',
                value: selectedCompanyId,
            })
        }
        const newData = filterBy(documents, filter);
        setDocumentsDatagrid(newData);
        setSkip(0);
    }, [documents, documentSearch, selectedCompanyId]);

    const onCompanyDropdownChange = (e) => setSelectedCompanyId(e.target.value)

    const [showDeleteAllDialog, setShowDeleteAllDialog] = useState(false);
    const [viewDocument, setViewDocument] = useState(false);
    const [gridAction, setGridAction] = useState('');

    const is1500 =  useMediaQuery('(max-width: 1500px)')
    const is1280 =  useMediaQuery('(max-width: 1280px)')
    const is960=  useMediaQuery('(max-width: 960px)')
    const showMobile = useMediaQuery('(max-width:721px)');
    const is560 = useMediaQuery('(max-width:560px)');

    useEffect(() => {
        if (gridAction === '' || !selectedDocument || !selectedDocument.id) return;

        if (gridAction === t('digitalVaultBinView.grid.btns.view.document')) {
            setViewDocument(true);
        } else if (gridAction === t('digitalVaultBinView.grid.btns.restore')) {
            restoreDocument();
        } else if (gridAction === t('digitalVaultBinView.grid.btns.delete')) {
            setViewDeleteDialog(true);
        }
    }, [selectedDocument, gridAction])

    if (isLoading) return <SimpleLoading />

    if (viewDocument && selectedDocument) {
        return <DigitalVaultDocumentAction
            id={selectedDocument.id}
            goBack={() => {
                const index = documentsDatagrid.findIndex(doc => doc.id === selectedDocument.id);
                setSkip(Math.floor(index / 6) * 6);
                setSelectedDocument(null);
                setViewDocument(false);
            }}
        />
    }

    let AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
    let CellColumnOne = (props) => <CellColumnName {...props} t={t} />
    let CellColumnTwo = (props) => <CellColumnDate {...props} t={t} />
    
    let widthCellOne = '200px'
    let widthCellTwo = '80px'
    let widthCellFive = '120px'

    if(is1500) widthCellFive = '140px'
    if(is1280) widthCellFive = '200px'
    if(is960) {
        widthCellOne = '150px'
        widthCellFive = '300px'
    }

    if(showMobile){
        widthCellOne = '100px'
        widthCellFive = '50px'
    }

    if(is560){
        widthCellOne = '200px'
        widthCellFive = '120px'
    }

    return (
        <>
            <Container disableGutters className='digitalVaultBinView'>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <div className='digitalVaultBinView-filters'>
                            <ButtonAddHLPure
                                nameBtn={t('digitalVaultBinView.btn.delete.all')}
                                iconAdd
                                onClickBtn={() => setShowDeleteAllDialog(true)}
                            />
                            <SearchBarHLPure
                                placeholder={t('digitalVaultBinView.placeholder.search.document')}
                                searchValue={documentSearch}
                                onSearchChange={(e) => setDocumentSearch(e.target.value)}
                            />
                            <DropDownBtnHLPure
                                optionsDropDown={companies}
                                optionsValue={selectedCompanyId}
                                valueItem={'id'}
                                nameOption={'companyName'}
                                onDropDownChange={onCompanyDropdownChange}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} className='digitalVaultBinView-grid'>
                        <GridSelectionHLPure
                            skip={skip}
                            take={6}
                            pageable
                            dataGrid={documentsDatagrid}

                            titleRow1={t('digitalVaultBinView.grid.title.1')}
                            headerColumnOne={AllHeadersColumns}
                            cellColumnOne={CellColumnOne}
                            widthColumnOne={widthCellOne}
                            minResizableWidth1={'auto'}
                            
                            columnTwo={(is560) ?  false : true}
                            titleRow2={t('digitalVaultAlertsView.grid.title.2')}
                            headerColumnTwo={AllHeadersColumns}
                            cellColumnTwo={CellColumnTwo}
                            widthColumnTwo={widthCellTwo}
                            minResizableWidth2={widthCellTwo}
                            
                            columnFive
                            columnFiveStyleClass={'digitalVaultBinView-cellActions'}
                            titleRow5={showMobile ? '' : t('digitalVaultBinView.grid.title.4')}
                            iconOneActive
                            labelOneActions={t('digitalVaultBinView.grid.btns.restore')}
                            iconFourthActive={!showMobile}
                            labelFourthActions={t('digitalVaultBinView.grid.btns.view.document')}
                            iconTrashActive
                            labelTrashActions={t('digitalVaultBinView.grid.btns.delete')}
                            widthColumnFive={widthCellFive}
                            minResizableWidth5={widthCellFive}
                            tooltipTrashIcon={t('digitalVaultBinView.grid.btns.delete.permanently')}

                            onSelectedItem={setSelectedDocument}
                            setNameComponentUser={setGridAction}
                            setShowDetails={() => { /* no ocupo */ }}
                        />
                    </Grid>
                </Grid>
            </Container>
            {
                viewDeleteDialog && <DialogYesNoHLPure
                    cancel={() => {
                        setViewDeleteDialog(false);
                    }}
                    textBtnCancel={t('button.cancel')}
                    saveBtn={t('button.delete')}
                    titleDialog={t('digitalVaultBinView.modal.title')}
                    handleSubmit={deleteDocument}
                >
                    <div className='digitalVaultBinView-modal-delete'>
                        <LabelModalPure label={`${t('digitalVaultBinView.modal.question')} ${selectedDocument.name}?`}/>
                    </div>
                </DialogYesNoHLPure>
            }
            {
                showDeleteAllDialog && <DialogYesNoHLPure
                    cancel={() => {
                        setShowDeleteAllDialog(false);
                    }}
                    textBtnCancel={t('button.cancel')}
                    saveBtn={t('button.delete')}
                    titleDialog={t('digitalVaultBinView.modal.all.title')}
                    handleSubmit={() => {
                        setShowDeleteAllDialog(false);
                        deleteMany(documentsDatagrid.map(d => d.id));
                    }}
                >
                    <div className='digitalVaultBinView-modal-delete-all'>
                        <LabelModalPure label={t('digitalVaultBinView.modal.all.question')}/>
                    </div>
                </DialogYesNoHLPure>
            }
        </>
    )
}

export default DigitalVaultBinView